import { Progress } from '@/components/ui/progress'
import { ReviewBody } from '@/types/collection'
import { useTranslations } from 'next-intl'

const bodyFitOptions = [
  {
    value: 'chat' as const,
    label: 'account_page.review_body_fit.tight',
  },
  {
    value: 'dung-kich-thuoc' as const,
    label: 'account_page.review_body_fit.perfect_fit',
  },
  {
    value: 'rong' as const,
    label: 'account_page.review_body_fit.loose',
  },
] as const

export const ProductReviewsSizeFitDistribution = ({
  bodyFit,
}: {
  bodyFit: ReviewBody[]
}) => {
  const t = useTranslations()
  if (!bodyFit.length) return null
  return (
    <div className='mt-4 lg:mt-0 lg:basis-2/5'>
      <p className='mb-1 font-criteria text-sm font-medium leading-4.5 text-neutral-900 lg:mb-5 lg:text-base'>
        {t('account_page.review_body_fit.title')}
      </p>
      {bodyFit.map((item) => (
        <ProductReviewsSizeFitDistributionItem key={item._id} bodyFit={item} />
      ))}
    </div>
  )
}

const ProductReviewsSizeFitDistributionItem = ({
  bodyFit,
}: {
  bodyFit: ReviewBody
}) => {
  const t = useTranslations()
  return (
    <div className='mb-2 last-of-type:mb-0 lg:flex lg:items-center lg:gap-3.5'>
      <p className='mb-0.5 whitespace-nowrap font-sans text-xs leading-3 text-neutral-600 lg:basis-28 lg:text-sm lg:leading-4.5'>
        {t(
          bodyFitOptions.find((option) => option.value === bodyFit.body_fit)
            ?.label || ''
        )}
      </p>
      <div className='flex items-center gap-2.5 lg:flex-1 lg:gap-2'>
        <Progress value={bodyFit.percentage} className='h-1 lg:h-2' />
        <p className='min-w-7 font-sans text-xs leading-3.5 text-neutral-600 md:min-w-8 lg:text-sm lg:leading-4.5'>
          {bodyFit.percentage}%
        </p>
      </div>
    </div>
  )
}
